export const createWrapSubscribeFunction = (patch, toObserver) => {
    const emptyFunction = () => { }; // tslint:disable-line:no-empty
    return (innerSubscribe) => {
        const subscribe = ((...args) => {
            const unsubscribe = innerSubscribe(toObserver(...args));
            if (unsubscribe !== undefined) {
                return unsubscribe;
            }
            return emptyFunction;
        });
        subscribe[Symbol.observable] = () => ({ subscribe: (...args) => ({ unsubscribe: subscribe(...args) }) });
        return patch(subscribe);
    };
};
//# sourceMappingURL=wrap-subscribe-function.js.map